<!-- FooterBar.vue -->
<script lang="ts" setup>
    import { ref, computed, onMounted, reactive, onUnmounted } from 'vue';

    const props = defineProps<{
        heightInRem?: number,
        backgroundColor?: string
    }>();

    const emits = defineEmits<{
        bottomVisible: [visible:boolean]
    }>();

    const compData = reactive<{
        isBottomVisible?: boolean,
        intervalId?: number
    }>({});

    const footerBarRef = ref();

    onMounted(async () =>{
        compData.intervalId = window.setInterval(checkIfBottomVisible, 250);

        document.body.style.marginBottom = (currentHeightInRem.value ??  + 1) + "rem";
    });
    onUnmounted(() =>{
        if (compData.intervalId)
            clearInterval(compData.intervalId);
    });

    const footerBarStyle = computed(() => { return {
        'height': currentHeightInRem.value, 
        'background-color': currentBackgroundColor.value
    }});

    function checkIfBottomVisible() {
        
        const position = document.documentElement.clientHeight + window.scrollY;
        const screenSize = (document.documentElement.scrollHeight ||document.documentElement.clientHeight);

        // Assume we're seeing the bottom if we are within 3 pixels
        if (screenSize - position < 3)
        {
            emitBottomVisibile(true);
            return;
        }
        emitBottomVisibile(false);
    }
    function emitBottomVisibile(isVisible: boolean)
    {
        if (compData.isBottomVisible !== isVisible)
        {
            compData.isBottomVisible = isVisible;
            emits("bottomVisible", compData.isBottomVisible);
        }        
    }

    function heightInPixels(): number {    
        return parseFloat(getComputedStyle(footerBarRef.value).height.replace("px", ""));
    }

    const currentHeightInRem = computed(() => props.heightInRem ?? 2.5);
    const currentBackgroundColor = computed(() => props.backgroundColor ?? "whitesmoke");
    
</script>

<style scoped>
    .footer
    {
        position: fixed;
        left: 0;
        bottom: 0;
        width: 100%;
        text-align: center;
        padding-top:0.25rem;
        padding-bottom:0.25rem;
        border-top:2px solid darkgrey
    }
    .footerBody
    {
        position: relative;
    }
    .leftSide
    {
        float: left;
    }
    .rightSide
    {
        float: right;
    }    

</style>

<template>
    <div ref="footerBarRef" class="footer" :style="footerBarStyle"> 
        <div class="footerBody ps-1">
            <div class="leftSide">
                <slot name="left"></slot>
            </div>
            <div class="rightSide pe-1">
                <slot name="right"></slot>
            </div>
            <div style="clear: both;"></div>            
        </div>
    </div>     
</template>
